import {faFileCode} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import React from "react"
import styles from "./index.module.scss"

export const NoReposContainer = () => {
  return (
    <div className={styles.NoReposContainer}>
      <FontAwesomeIcon icon={faFileCode} className={styles.NoReposIcon}/>
      <div className={styles.NoReposText}>You do not have any repository yet</div>
    </div>
  )
}
